import "./styles/Waiting.css";

export default function Waiting() {
    return (
        <div className="waiting">
            <div className="waiting__container">
                <div className="waiting__spinner" />
                <h2 className="waiting__title">
                    Waiting for  opponent<span className="waiting__dots"></span>
                </h2>
            </div>
        </div>
    )
}